import { render } from "./PaiementSuccessPage.vue?vue&type=template&id=7043d0c6&ts=true"
import script from "./PaiementSuccessPage.vue?vue&type=script&lang=ts"
export * from "./PaiementSuccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__